import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from 'investira.react.components';
import FeederMasterListItem from './FeederMasterListItem';
import FeederMasterListSkeleton from './FeederMasterListSkeleton';

const FeederMasterList = memo(props => {
  const { feedersMaster, pessoasById, onRemove, onModify, isLoading } = props;

  if (isLoading) {
    return <FeederMasterListSkeleton />;
  }

  if (!feedersMaster.length) {
    return (
      <Stack sx={{ p: 4 }} alignItems="center" justifyContent="center">
        <Typography variant="body2" color="textSecondary">
          Nenhum vínculo cadastrado.
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack>
      <Stack mb={2}>
        <Typography color="textSecondary" variant="caption">
          Relacionamentos Feeder/Master
        </Typography>
      </Stack>

      <Stack component="ul" sx={{ m: 0, p: 0 }}>
        {feedersMaster.map(xRelationship => {
          const xPessoaId = Number(xRelationship?.pessoa_id);
          const xMasterPessoaId = Number(xRelationship?.master_pessoa_id);

          return (
            <FeederMasterListItem
              key={`${xPessoaId}-${xMasterPessoaId}`}
              relationship={xRelationship}
              pessoasById={pessoasById}
              onRemove={onRemove}
              onModify={onModify}
            />
          );
        })}
      </Stack>
    </Stack>
  );
});

FeederMasterList.propTypes = {
  feedersMaster: PropTypes.arrayOf(
    PropTypes.shape({
      pessoa_id: PropTypes.number,
      master_pessoa_id: PropTypes.number
    })
  ),
  pessoasById: PropTypes.object,
  onRemove: PropTypes.func,
  onModify: PropTypes.func,
  isLoading: PropTypes.bool
};

FeederMasterList.defaultProps = {
  feedersMaster: [],
  pessoasById: {},
  onRemove: () => {},
  onModify: () => {},
  isLoading: false
};

FeederMasterList.displayName = 'FeederMasterList';

export default FeederMasterList;
